import type { Activity } from '../types'

function time(value: string) {
  return new Intl.DateTimeFormat('en', {
    hour: 'numeric',
    minute: '2-digit',
  }).format(new Date(value))
}

export function ActivityRail({ events, onViewAll }: { events: Activity[]; onViewAll: () => void }) {
  return (
    <aside className="activity-rail">
      <header>
        <strong>Webhook activity</strong>
        <span className="status-text">
          <i className="square success" /> Healthy
        </span>
      </header>
      <div className="event-timeline">
        {events.map((event) => (
          <article key={event.id}>
            <i className="timeline-dot" />
            <time>{time(event.occurred_at)}</time>
            <strong>{event.event_type}</strong>
            <span>{event.entity_id}</span>
            <em>{event.outcome}</em>
          </article>
        ))}
      </div>
      <button className="view-events" type="button" onClick={onViewAll}>
        View all events
      </button>
    </aside>
  )
}
